import api from "../config/api";

export const fetchCustomer= async ()=>{
    const res = await api.get(`/customer/`)
    return res.data.data;
}

export const fetchCustomerById= async (id)=>{
    const res = await api.get(`/customer/?id=${id}`, id)
    return res.data.data;
}

export const createCustomer= async (customerData)=>{
    const res = await api.post(`/customer/`,customerData)
    return res.data.data;
}

export const updateCustomer= async(id,customerData)=>{
    const res = await api.post(`/customer/?id=${id}`,customerData)
    return res.data;
}

export const deleteCustomer= async(id)=>{
    const res = await api.delete(`/customer/?id=${id}`)
    return res.data;
}